import Vue from 'vue'
import Router from 'vue-router'

import Landing from '@/views/LAnding.vue'   // ⬅️ NUEVA landing
import Login from '@/views/Login.vue'
import Main from '@/views/Main.vue'
import Agreement from '@/views/agreement/Agreement.vue'
import Calendar from '@/views/calendar/Calendar.vue'
import Notices from '@/views/notices/Notices.vue'
import Workers from '@/views/workers/Workers.vue'
import Suggestions from '@/views/suggestions/Suggestions.vue'
import RequestAccess from '@/views/RequestAccess.vue'
import Managers from '@/views/admin/Managers.vue'
import AccessRequests from '@/views/admin/AccessRequests.vue'


import Cookies from '@/views/info/Cookies.vue'
import LegalAdvice from '@/views/info/LegalAdvice.vue'
import PrivacyPolicy from '@/views/info/PrivacyPolicy.vue'

import store from '@/store'
import i18n from '@/i18n'

Vue.use(Router)

const routes = [

  // 🌐 NUEVA LANDING PAGE
  {
    path: '/',
    name: 'landing',
    component: Landing
  },

  // 🔐 LOGIN MOVIDO A /login
  {
    path: '/login',
    name: 'login',
    component: Login
  },

{
  path: '/home',
  component: Main,
  meta: { requiresAdmin: true },
  children: [
    { path: '', redirect: 'notices' }, // 👈 REDIRECCIÓN AUTOMÁTICA AL ENTRAR EN /home
    { path: 'agreement', name: 'agreement', component: Agreement },
    { path: 'notices', name: 'notices', component: Notices },
    { path: 'calendar', name: 'calendar', component: Calendar },
    { path: 'workers', name: 'workers', component: Workers },
    { path: 'suggestions', name: 'suggestions', component: Suggestions },
    { path: 'managers', name: 'managers', component: Managers, meta: { requiresSuperAdmin: true } },
    { path: 'access-requests', name: 'access-requests', component: AccessRequests, meta: { requiresSuperAdmin: true } },
    
  ]
},
{
  path: '/request-access',
  name: 'request-access',
  component: RequestAccess
},

  // 🔑 INFO
  { path: '/cookies', alias: '/politica-de-cookies', name: 'cookies', component: Cookies },
  { path: '/legal-advice', alias: '/aviso-legal', name: 'legal-advice', component: LegalAdvice },
  { path: '/privacy-policy', alias: '/politica-de-privacidad', name: 'privacy-policy', component: PrivacyPolicy },
  // fallback
  { path: '*', redirect: '/' }
]

const router = new Router({
  mode: 'history',
  routes
})

// 🛡️ GUARD DE RUTAS
router.beforeEach(async (to, from, next) => {
  // ensure auth listener initialized
  if (!store.getters["auth/inited"]) {
    await store.dispatch("auth/initAuth");
  }

  const authed = store.getters["auth/isAuthed"];

  // Rutas publicas (accesibles sin login)
  const publicPaths = [
    "/",
    "/login",
    "/request-access",
    "/cookies",
    "/politica-de-cookies",
    "/legal-advice",
    "/aviso-legal",
    "/privacy-policy",
    "/politica-de-privacidad"
  ];
  const isPublic =
    publicPaths.includes(to.path) || to.path.startsWith("/invite/");

  if (!authed && !isPublic) {
    return next("/login");
  }

  if (to.matched.some(record => record.meta.requiresAdmin) && !store.getters["auth/canAccessAdminPanel"]) {
    await store.dispatch("auth/logout");
    await store.dispatch("auth/setAuthError", i18n.t("login.noPermission"));
    return next("/login");
  }

  if (to.matched.some(record => record.meta.requiresSuperAdmin) && !store.getters["auth/isSuperAdmin"]) {
    return next("/home/notices");
  }

  if (authed && to.path === "/login") {
    return next("/home/notices");
  }

  next();
});

export default router
